/** ****************************************************************************
		███╗   ██╗███████╗██████╗  █████╗  ██████╗
		████╗  ██║██╔════╝██╔══██╗██╔══██╗██╔═══██╗
		██╔██╗ ██║█████╗  ██║  ██║███████║██║   ██║
		██║╚██╗██║██╔══╝  ██║  ██║██╔══██║██║   ██║
		██║ ╚████║███████╗██████╔╝██║  ██║╚██████╔╝
		╚═╝  ╚═══╝╚══════╝╚═════╝ ╚═╝  ╚═╝ ╚═════╝

@description Composant affichant deux bouton "call to action"

@author Victor Audetat <audetat.v@gmail.com>

@copyright © 2020  NEDAO Association (info@nedao.ch)
@see {@link https://association.nedao.ch}

@license
	This program is free software: you can redistribute it and/or modify
	it under the terms of the GNU Affero General Public License as published
	by the Free Software Foundation, either version 3 of the License, or
	(at your option) any later version.

	This program is distributed in the hope that it will be useful,
	but WITHOUT ANY WARRANTY; without even the implied warranty of
	MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
	GNU Affero General Public License for more details.

	You should have received a copy of the GNU Affero General Public License
	along with this program.  If not, see <https://www.gnu.org/licenses/>.
*******************************************************************************/

import React from "react";
import {LeanButton} from "nedao-branding";
import MailTo from "../MailTo";
import "./call-to-action.scss";

const CallToAction = () => {
	return (
		<div className="call-to-action__container">
			<MailTo subject="Demande d'adhésion membre NEDAO ASSOCIATION">
				<LeanButton
					text="Devenir membre"
				/>
			</MailTo>
			<MailTo subject="Demande de partenariat NEDAO ASSOCIATION">
				<LeanButton
					text="Devenir partenaire"
				/>
			</MailTo>
		</div>
	);
};

export default CallToAction;